"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const operation_1 = require("../../operation");
const api_1 = require("./api");
/**
 * Broadcast the signed transaction
 * @param {signature: string, operation: string} signedOperation
 */
const broadcast = ({ signedOperation: { signature, operation, signatureRaw }, }) => __awaiter(void 0, void 0, void 0, function* () {
    const hash = yield (0, api_1.broadcastTransaction)({
        signatureRaw,
        signature,
    });
    return (0, operation_1.patchOperationWithHash)(operation, hash);
});
exports.default = broadcast;
//# sourceMappingURL=js-broadcast.js.map